module.exports = "pegasus_template/assets/image-1-basic.png";